// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"194":"f356e335b78605c2","200":"23549a91141f7d53","334":"669a261380374549","371":"4f7357bd4beb1f43","608":"6445a3c75b18f3c9","644":"8ae2635465fec38f","653":"6c30ce99251bd627","850":"9094ce8c75d867bf","965":"8e2ffa6753f3c9d9","971":"3a696fc0f17748a6"}[chunkId] + ".js";
};